import { IDmKhoiNganhActionTypes } from "../../action-types/category/IDmKhoiNganhActions";
import { IDmKhoiNganhReducer } from "../../reducer-model/category/IDmKhoiNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmKhoiNganhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  khoiNganhs: [],
};
export const khoiNganhReducer = (
  state: IDmKhoiNganhReducer = iniState,
  action: IDmKhoiNganhActionTypes
): IDmKhoiNganhReducer => {
  switch (action.type) {
    case "KHOI_NGANH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KHOI_NGANH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        khoiNganhs: action.payload,
      };
    case "KHOI_NGANH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
